import { Environment } from "@ffld/domain";
import { ApplicationContainer } from "@ffld/loader";

export async function loadEnvironments({applicationName}: {applicationName: string}): Promise<Environment[]> {
    return await ApplicationContainer.getApplicationAPI().getApplicationEnvironments(applicationName);
}